import { IEventsStore } from './index'

export default {
  events: [],
  fullyLoaded: false,
  loadedDates: [],
  pdf: '',
  pdfRequest: {
    errMessage: '',
    isLoading: false,
    isSaving: false,
  },
  request: {
    events: {
      acceptedCount: 0,
      errMessage: '',
      isFallbackLoading: false,
      isLoading: false,
    },
  },
} as IEventsStore
